import { useState } from "react";
import Icon from "../ui/Icon";
import MiniSpinner from "../ui/MiniSpinner";
import { THEMES } from "../../config/constants";
import { qbCall } from "../../utils/api";
import { inpStyle, lbl, secT, btnP, btnS } from "../../utils/styles";

export default function NewQBCustomerModal({ onClose, onCreated, theme, prefill }) {
  const t = THEMES[theme];
  const [form, setForm] = useState({
    title: "", firstName: prefill?.firstName || (prefill?.name || "").split(" ")[0] || "",
    middleName: "", lastName: prefill?.lastName || (prefill?.name || "").split(" ").slice(1).join(" ") || "",
    suffix: "", companyName: prefill?.businesses?.[0]?.legalName || "",
    email: prefill?.email || "", phone: prefill?.phone || "",
    ccEmail: "", bccEmail: "", mobile: "", fax: "", other: "", website: "", checksName: "",
    line1: prefill?.address || "", city: prefill?.city || "", state: prefill?.state || "", zip: prefill?.zip || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const displayNameOptions = [
    [form.firstName, form.lastName].filter(Boolean).join(" "),
    [form.lastName, form.firstName].filter(Boolean).join(", "),
    form.companyName,
  ].filter(Boolean);
  const [displayName, setDisplayName] = useState("");

  const handleCreate = async () => {
    const name = displayName || displayNameOptions[0] || form.companyName;
    if (!name) { setError("Enter a first/last name or company name."); return; }
    setSaving(true); setError("");
    try {
      const result = await qbCall("qbCreateCustomer", {
        firstName: form.firstName, lastName: form.lastName, companyName: form.companyName,
        email: form.email, phone: form.phone,
        billingAddress: { line1: form.line1, city: form.city, state: form.state, zip: form.zip },
      });
      onCreated(result.customer);
    } catch (e) { setError(e.message); }
    setSaving(false);
  };

  const F = ({ label, k, half, third, placeholder, type }) => (
    <div style={{ flex: half ? 1 : third ? 1 : "none", width: (half || third) ? undefined : "100%", minWidth: 0, marginBottom: 12 }}>
      <label style={{ ...lbl, color: t.textSub }}>{label}</label>
      <input type={type || "text"} style={inpStyle(t)} value={form[k]} onChange={e => set(k, e.target.value)} placeholder={placeholder || ""} />
    </div>
  );

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", display:"flex", alignItems:"center", padding: 4 }}><Icon name="arrow" size={18} color={t.textSub} /></button>
        <div style={{ fontSize: 13, color: t.textMuted, fontWeight: 600 }}>QuickBooks</div>
      </div>
      <div style={{ background: t.surface, border: `1px solid ${t.border}`, borderRadius: 16, padding: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800, color: t.text }}>New QuickBooks Customer</div>
            <div style={{ fontSize: 12, color: t.textMuted, marginTop: 3 }}>Name and contact info</div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer" }}><Icon name="x" size={18} color={t.textSub} /></button>
        </div>

        {/* Name row */}
        <div style={{ display: "grid", gridTemplateColumns: "80px 1fr 1fr 1fr 80px", gap: 10, marginBottom: 14 }}>
          <div><label style={{ ...lbl, color: t.textSub }}>Title</label><input style={inpStyle(t)} value={form.title} onChange={e => set("title", e.target.value)} placeholder="Mr." /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>First name</label><input style={inpStyle(t)} value={form.firstName} onChange={e => set("firstName", e.target.value)} placeholder="Jane" /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Middle name</label><input style={inpStyle(t)} value={form.middleName} onChange={e => set("middleName", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Last name</label><input style={inpStyle(t)} value={form.lastName} onChange={e => set("lastName", e.target.value)} placeholder="Smith" /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Suffix</label><input style={inpStyle(t)} value={form.suffix} onChange={e => set("suffix", e.target.value)} placeholder="Jr." /></div>
        </div>

        {/* Company + Display name */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div><label style={{ ...lbl, color: t.textSub }}>Company name</label><input style={inpStyle(t)} value={form.companyName} onChange={e => set("companyName", e.target.value)} placeholder="Type to search" /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Customer display name *</label>
            <select style={inpStyle(t)} value={displayName} onChange={e => setDisplayName(e.target.value)}>
              <option value="">Select display name...</option>
              {displayNameOptions.map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
        </div>

        {/* Contact fields */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div><label style={{ ...lbl, color: t.textSub }}>Email</label><input type="email" style={inpStyle(t)} value={form.email} onChange={e => set("email", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Phone number</label><input style={inpStyle(t)} value={form.phone} onChange={e => set("phone", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>CC</label><input style={inpStyle(t)} value={form.ccEmail} onChange={e => set("ccEmail", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>BCC</label><input style={inpStyle(t)} value={form.bccEmail} onChange={e => set("bccEmail", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Mobile number</label><input style={inpStyle(t)} value={form.mobile} onChange={e => set("mobile", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Fax</label><input style={inpStyle(t)} value={form.fax} onChange={e => set("fax", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Other</label><input style={inpStyle(t)} value={form.other} onChange={e => set("other", e.target.value)} /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>Website</label><input style={inpStyle(t)} value={form.website} onChange={e => set("website", e.target.value)} /></div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ ...lbl, color: t.textSub }}>Name to print on checks</label>
          <input style={inpStyle(t)} value={form.checksName} onChange={e => set("checksName", e.target.value)} />
        </div>

        <div style={{ ...secT(t) }}>Billing Address</div>
        <div style={{ marginBottom: 12 }}><label style={{ ...lbl, color: t.textSub }}>Street Address</label><input style={inpStyle(t)} value={form.line1} onChange={e => set("line1", e.target.value)} placeholder="123 Main St" /></div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 80px 100px", gap: 12 }}>
          <div><label style={{ ...lbl, color: t.textSub }}>City</label><input style={inpStyle(t)} value={form.city} onChange={e => set("city", e.target.value)} placeholder="San Diego" /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>State</label><input style={inpStyle(t)} value={form.state} onChange={e => set("state", e.target.value)} placeholder="CA" /></div>
          <div><label style={{ ...lbl, color: t.textSub }}>ZIP</label><input style={inpStyle(t)} value={form.zip} onChange={e => set("zip", e.target.value)} placeholder="92101" /></div>
        </div>

        {error && <div style={{ background: "#2a0e0e", border: "1px solid #5a1010", borderRadius: 8, padding: "10px 14px", color: "#f87171", fontSize: 12.5, marginBottom: 14 }}>{error}</div>}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20, paddingTop: 18, borderTop: `1px solid ${t.border}` }}>
          <button onClick={onClose} style={{ ...btnS(t), display:"flex", alignItems:"center", gap:6 }}><Icon name="arrow" size={13} color={t.textSub}/>Back</button>
          <button onClick={handleCreate} disabled={saving} style={btnP}>
            {saving ? <><MiniSpinner size={14} color="#fff"/>Saving...</> : <><Icon name="plus" size={14} color="#fff" />Save Customer</>}
          </button>
        </div>
      </div>
    </div>
  );
}

